/* eslint-disable @typescript-eslint/naming-convention */
import { Box, Button, Flex, Text } from "@chakra-ui/react"
import React, { useEffect, useState } from "react"
import { breadCrumbAccessoriesThirdLevel, breadCrumbFirstLevel, breadCrumbProductsSecondLevel } from "../common/commonConstants"
import { BreadCrumb } from "../components/commons/breadcrumb"
// import bg from '../assets/images/all-products.png'
import { ProductThumbnailType6 } from "@/components/commons/productThumbnailType6"
import { useAllCollarsQuery } from "@/type-and-hooks"
import { useLocation, useNavigate } from "react-router-dom"
import { SubPage, SubPageContent } from "../components/SubPage"


export const ProductSubPage = (): JSX.Element => {
  const location = useLocation()
  const [pathName, setPathName] = useState<string>("")
  const navigate = useNavigate()

  const subCategory = pathName.toLowerCase().replaceAll(" - ", "-").replaceAll(" / ", "-").replaceAll(" ", "-")

  useEffect(() => {
    if (location) {
      const tmp = location.pathname.slice(location.pathname.lastIndexOf("/") + 1, location.pathname.length)
      setPathName(tmp.toUpperCase().replaceAll("_", "/").replaceAll("-", " "))
    }
  }, [location])

  const { loading, data } = useAllCollarsQuery({ variables: { collarTypeId: subCategory }, fetchPolicy: "cache-and-network" })

  const subCategoryDescription = data?.allCollars?.[0]?.sub_category_description ?? null

  // Get product count
  const productCount = data?.allCollars?.length ?? 0

  return (
    <SubPage>
      {/* <BannerType1 heading={pathName} image={bgBlanks} subText2Styles={{ marginTop: "59px" }} imageStyles={{ width: "100%", height: "100%" }} /> */}
      <BreadCrumb
        options={{
          ...breadCrumbFirstLevel,
          ...breadCrumbProductsSecondLevel,
          ...breadCrumbAccessoriesThirdLevel,
          fourthLevel: { title: pathName }
        }}
      />
      <SubPageContent>
        {/* Description Section */}
        <Box pt="4px" pb="16px" mb="20px" textAlign={"center"}>
          {subCategoryDescription && (
            <Text fontSize="16px" lineHeight="24px" mb="24px" whiteSpace="pre-line">
              {subCategoryDescription}
            </Text>
          )}
          <Button variant="Button1Regular" onClick={() => navigate("/distributors")}>
            Buy From Distributor
          </Button>
        </Box>

        {/* Product Count (Left) and Instructions (Right) */}
        <Flex justify="space-between" align="flex-start" mb="4px">
          {/* Product Count - Left Side */}
          <Text fontSize="12px" color="gray.400" fontWeight="400">
            {productCount} items
          </Text>
        </Flex>

        {/* Products Grid */}
        <Box mb="8px" data-name="products-grid">
          <Flex flexWrap="wrap" justifyContent="center" gap="2px">
            {data?.allCollars?.map((item, index) => (
              <ProductThumbnailType6 key={`${index}_allCollars`} prodCode={item?.prod_code} prodPhoto={item?.prod_photo} bg={"#F6F5F3"} />
            ))}
          </Flex>
        </Box>
      </SubPageContent>
    </SubPage>
  )
}
